<template>
  <v-toolbar
    color="white"
    fixed
    elevation="8"
    class="pl-6 align-center"
  >
    <img
      src="@/assets/logo/ochpower.svg"
      width="150"
      alt=""
    >
    <v-spacer />
    <SelectLanguageInput
      style="max-width: 150px;"
      real-time-mode
      class="mr-5"
    />
  </v-toolbar>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SelectLanguageInput from '@/components/parts/inputs/SelectLanguageInput'

  export default {
    components: { SelectLanguageInput },
    computed: {
      ...mapGetters(['ui'])
    },
    created () {
      this.$i18n.locale = this.getBrowserLanguage()
    },
    methods: {
      getBrowserLanguage () {
        let language = (window.navigator.languages && window.navigator.languages[0]) ||
          window.navigator.language ||
          window.navigator.userLanguage ||
          window.navigator.browserLanguage
        if (language.indexOf('-')) {
          language = language.split('-')[0]
        }
        return language
      }
    }
  }
</script>

<style scoped>

</style>
